import React from 'react';
import Container from 'react-bootstrap/Container';
import { useLocation, useParams } from 'react-router-dom';

import  Header from '../../components/Header';
import SanitizedHTML from '../../components/SanitizedHTML';

function TermsOfUsePage() {
  const location = useLocation();
  const { cp } = useParams();
  const [cpTerms, setCpTerms] = React.useState(JSON.parse(localStorage.getItem(`${cp}-terms`)));

  React.useEffect(() => {
    localStorage.removeItem(`${cp}-terms`);
  }, [cp]);

  React.useEffect(() => {
    if (location.state) {
      setCpTerms(location.state);
    }
  }, [location]);

  return (
    <div className="TermsOfUsePage">
      <Header
          image={{src: require('../../client/assets/logo.png'), alt: 'VTR'}}
        />
      <Container>
        <SanitizedHTML
          html={cpTerms}
        />
      </Container>
    </div>
  );
}

export default TermsOfUsePage;